import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Button from "../common/button/button";
import Form from "./documentoForm";
import Select from "../common/form/select";

import { getUcValidarUsuarioImplantacao } from "../cliente/clienteActions";
import { adicionarBloqueioUsuarioImplantacao } from "../utils/adicionarBloqueioUsuarioImplantacao";
import { setModoTela, initForm, setFiltro, salvar, excluir, getLista, getListaCliente, getListaUnidadeConsumidora, getListaDocumentoTipo } from "./documentoActions";
import { Loading } from "../common/loading/loading";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";

function Documento(props) {
    const [state, setState] = useState({
        exibirModalGestorConcessionaria: false,
        itemSelecionado: null,
    });

    //Sem acesso
    if (!props.usuarioLogado) {
        return <div />;
    }

    useEffect(() => {
        props.getUcValidarUsuarioImplantacao();

        props.getListaCliente();
        props.getListaUnidadeConsumidora();
        props.getListaDocumentoTipo();

        if (props.usuarioLogado.acesso_cliente) {
            props.setFiltro({
                ...props.filtro,
                id_cliente: props.usuarioLogado.id_cliente,
            });
        } else {
            props.getLista();
        }
    }, []);

    useEffect(() => {
        props.getLista();
    }, [props.filtro]);

    return (
        <div>
            {props.aguardando ? <Loading /> : null}

            <Content>
                {props.modoTela === "visualizacao" ? <Form onSubmit={() => {}} visualizacao /> : null}
                {props.modoTela === "cadastro" ? <Form onSubmit={props.salvar} /> : null}
                {props.modoTela === "exclusao" ? <Form excluir onSubmit={props.excluir} /> : null}
                {props.modoTela === "lista" ? lista() : null}
            </Content>
        </div>
    );

    function lista() {
        const acessoCliente = !!props.usuarioLogado.acesso_cliente;
        const usuarioEdicao = !!props.usuarioLogado.acesso_documento_editar;

        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                <ContentCardHeader>
                    {usuarioEdicao ? (
                        <Row>
                            <Grid cols="6 6 4 2">
                                <Button
                                    text="Adicionar"
                                    type={"success"}
                                    icon={"fa fa-plus"}
                                    disabled={!usuarioEdicao}
                                    event={() => {
                                        props.setModoTela("cadastro", {});
                                        props.initForm({ anexos: [] });
                                    }}
                                />
                            </Grid>
                        </Row>
                    ) : null}
                </ContentCardHeader>
                <ContentCardBody>
                    <Row>
                        {!acessoCliente ? (
                            <Select
                                name="id_cliente"
                                options={props.listaCliente}
                                label="Cliente"
                                cols="12 6 4"
                                placeholder="Selecione o Cliente"
                                value={props.filtro.id_cliente}
                                onChange={(value) => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_cliente: value,
                                    });
                                }}
                            />
                        ) : null}

                        <Select
                            name="id_unidade_consumidora"
                            options={props.listaUnidadeConsumidora.filter((item) => !props.filtro.id_cliente || item.id_cliente == props.filtro.id_cliente)}
                            label={
                                <LabelSelectUcIconeGestor
                                    filtro={props.filtro}
                                    listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                    setExibirModal={(ucFiltro) =>
                                        setState({
                                            ...state,
                                            exibirModalGestorConcessionaria: true,
                                            itemSelecionado: ucFiltro,
                                        })
                                    }
                                />
                            }
                            cols="12 6 4"
                            placeholder="Selecione a UC"
                            value={props.filtro.id_unidade_consumidora}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_unidade_consumidora: value,
                                });
                            }}
                        />
                        <Select
                            name="id_documento_tipo"
                            options={props.listaDocumentoTipo}
                            label="Tipo"
                            cols="12 6 4"
                            placeholder="Selecione o Tipo de Documento"
                            value={props.filtro.id_documento_tipo}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_documento_tipo: value,
                                });
                            }}
                        />
                    </Row>

                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky>Cliente</Th>
                                <Th sticky>Unidade Consumidora</Th>
                                <Th sticky>Tipo</Th>
                                <Th sticky>Documento</Th>
                                <Th sticky minWidth={70}>
                                    Data
                                </Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {props.lista.map((item) => {
                                const botoes = [
                                    {
                                        type: "primary",
                                        icon: "fas fa-eye",
                                        disabled: !usuarioEdicao,
                                        event: () => {
                                            let registro = {
                                                ...item,
                                                vigencia_inicio: `${String(item.vigencia_inicio).substring(4, 6)}/${String(item.vigencia_inicio).substring(0, 4)}`,
                                                vigencia_fim: `${String(item.vigencia_fim).substring(4, 6)}/${String(item.vigencia_fim).substring(0, 4)}`,
                                            };
                                            props.setModoTela("visualizacao", registro);
                                            props.initForm(registro);
                                        },
                                    },
                                ];

                                if (!acessoCliente) {
                                    botoes.push(
                                        {
                                            type: "warning",
                                            icon: "fas fa-pencil-alt",
                                            disabled: !usuarioEdicao || item.bloquearEdicaoUsuarioImplantacao,
                                            event: () => {
                                                let registro = {
                                                    ...item,
                                                    vigencia_inicio: `${String(item.vigencia_inicio).substring(4, 6)}/${String(item.vigencia_inicio).substring(0, 4)}`,
                                                    vigencia_fim: `${String(item.vigencia_fim).substring(4, 6)}/${String(item.vigencia_fim).substring(0, 4)}`,
                                                };
                                                props.setModoTela("cadastro", registro);
                                                props.initForm(registro);
                                            },
                                        },
                                        {
                                            type: "danger",
                                            icon: "fas fa-trash-alt",
                                            disabled: !usuarioEdicao || item.bloquearEdicaoUsuarioImplantacao,
                                            event: () => {
                                                let registro = {
                                                    ...item,
                                                    vigencia_inicio: `${String(item.vigencia_inicio).substring(4, 6)}/${String(item.vigencia_inicio).substring(0, 4)}`,
                                                    vigencia_fim: `${String(item.vigencia_fim).substring(4, 6)}/${String(item.vigencia_fim).substring(0, 4)}`,
                                                };
                                                props.setModoTela("exclusao", registro);
                                                props.initForm(registro);
                                            },
                                        }
                                    );
                                }
                                return (
                                    <NewTr key={item.id} backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"} botoes={botoes}>
                                        <Td>{item.nome_cliente}</Td>
                                        <Td>{item.nome_unidade_consumidora}</Td>
                                        <Td>{item.nome_documento_tipo}</Td>
                                        <Td>{item.nome}</Td>
                                        <Td>{item.vigencia_inicio ? `${String(item.vigencia_inicio).substring(4, 6)}/${String(item.vigencia_inicio).substring(0, 4)}` : null}</Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.documento.modoTela,
    formularioValues: getFormValues("documentoForm")(state),
    aguardando: state.documento.aguardando,
    filtro: state.documento.filtro,
    lista: adicionarBloqueioUsuarioImplantacao(state.auth.usuarioLogado, state.cliente.listaUcValidarUsuarioImplantacao, state.documento.lista),
    listaCliente: state.documento.listaCliente,
    listaUnidadeConsumidora: state.documento.listaUnidadeConsumidora,
    listaDocumentoTipo: state.documento.listaDocumentoTipo,
    listaMeses: state.documento.listaMeses,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            salvar,
            excluir,
            getLista,
            getListaCliente,
            getListaUnidadeConsumidora,
            getListaDocumentoTipo,
            getUcValidarUsuarioImplantacao,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(Documento);
